import Vue from 'vue'
import BIMDataDesignSystem from '@bimdata/design-system/plugin.js'

Vue.use(BIMDataDesignSystem())
